// src/components/shift/ShiftStartDialog.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { translations } from '../../utils/translations';

const ShiftStartDialog = ({ onClose, onSubmit }) => {
  const { language } = useApp();
  const t = translations[language];
  
  const [openingCash, setOpeningCash] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ opening_cash: parseFloat(openingCash) || 0 });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-md">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-xl font-bold">
            {language === 'en' ? 'Start Shift' :
             language === 'km' ? 'ចាប់ផ្តើមវេន' :
             '开始班次'}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">
              {language === 'en' ? 'Opening Cash Amount' :
               language === 'km' ? 'ចំនួនទឹកប្រាក់បើក' :
               '期初金额'}
            </label>
            <input
              type="number"
              step="0.01"
              value={openingCash}
              onChange={(e) => setOpeningCash(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="0.00"
              required
            />
            <p className="text-sm text-gray-500 mt-1">
              {language === 'en' ? 'Enter the cash amount in the register' :
               language === 'km' ? 'បញ្ចូលចំនួនទឹកប្រាក់ក្នុងម៉ាស៊ីនគិតលុយ' :
               '输入收银台中的现金金额'}
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-700">
              {language === 'en' 
                ? '💡 Tip: Count all cash in the register before starting your shift.'
                : language === 'km'
                ? '💡 ចំណាំ: រាប់ទឹកប្រាក់ទាំងអស់ក្នុងម៉ាស៊ីនគិតលុយមុនពេលចាប់ផ្តើមវេនរបស់អ្នក។'
                : '💡 提示: 开始班次前请清点收银台中的所有现金。'}
            </p>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              {t.cancel}
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              {language === 'en' ? 'Start' :
               language === 'km' ? 'ចាប់ផ្តើម' :
               '开始'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShiftStartDialog;